import { Box, Dialog, DialogContent, IconButton, Grid, CircularProgress } from '@mui/material';
import { BackgroundStyle, HeadingTitle } from "../../assets/style";
import { photoIcon } from '../../assets/imgs';
import { useEffect, useState } from "react";
import MainContent from '../../components/MainContent';
import { latestPhotoPageName } from "../../components/PageName";
import { useLazyGetLatestPhotoListQuery } from "../../features/photo/photoSlice";
import RecordTableV2, { TableHeader } from "../../components/RecordTableV2";
import { RecordModel } from "../../models/RecordModel";
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { logOut } from '../../features/auth/authSlice';
import SignalIndicator from '../../components/SignalIndicator';
import PhotoSphereViewerComponent from '../../components/PhotoSphereViewerComponent';


const LatestPhotoRecord = () => {
    const [getLatestPhotoList] = useLazyGetLatestPhotoListQuery();
    const [tableRows, setTableRows] = useState<any[]>([]);
    const [data, setData] = useState<RecordModel<any>>();
    const [selectedStation, setSelectedStation] = useState<string>('');
    const [selectedImage, setSelectedImage] = useState<string | null>(null);
    const [isImageOpen, setIsImageOpen] = useState(false);
    const [selectedPerspectiveImage, setSelectedPerspectiveImage] = useState<string[] | null>(null);
    const [isPerspectiveImageOpen, setIsPerspectiveImageOpen] = useState(false);
    const [isLoading, setLoading] = useState<boolean>(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const getColumns = (): TableHeader[] => [
        { field: 'stationName', headerName: t("Location"), width: 300, isSortable: false,
            renderCell: (params: any) => (
                <div onClick={(e) => {
                    navigate(`/recordDetail?stationName=${params.value}`);
                    }}
                >
                    {params.value}
                </div>
            )
        },
        { field: 'uploadDate', headerName: t("Date"), width: 200, isSortable: false },
        {
            field: "thumbnailUrl",
            headerName: t("360° Photo"),
            width: 150,
            renderCell: (params: any) => (
                <Box
                    sx={{
                        width: 60,
                        height: 60,
                        borderRadius: 1,
                        overflow: 'hidden',
                        cursor: 'pointer',
                        '&:hover': {
                            boxShadow: 2,
                            transform: 'scale(1.05)'
                        },
                        transition: 'all 0.2s'
                    }}
                    onClick={(e) => {
                        e.stopPropagation();
                        handlePhotoClick(params);
                    }}
                >
                    <img
                        src={`${params.value}?token=${localStorage.getItem('accessToken')}`}
                        alt="Thumbnail"
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover'
                        }}
                    />
                </Box>
            )
        },
        {
            field: "photoPerspectiveUrls",
            headerName: t("Perspective Photo"),
            width: 150,
            renderCell: (params: any) => (
                <Box
                    onClick={(e) => {
                        e.stopPropagation();
                        handlePerspectivePhotoClick(params.value);
                    }}
                >
                    <img src={photoIcon} alt='logo' />
                </Box>
            )
        },
        ...(tableRows.some((row: any) => row.rubbishRating !== null) ? [{
            field: "rubbishRating",
            headerName: t("Rubbish Level"),
            width: 150,
            renderCell: (params: any) => (
                <Box>
                    <SignalIndicator signalLevel={params.value} size='medium'/>
                </Box>
            )
        }] : []),
    ];


    const fetchDataForPage = async (pageNumber: any) => {
        // Fetch data for the specified page from the backend
        const data = await getLatestPhotoList(
            {
                page: pageNumber,
                sortBy: 'uploadDate',
                sortDirection: 'asc'
            }
        );

        if (data.status === 'fulfilled') {
            return data.data.records.map((item: any) => ({
                id: item?.id,
                stationId: item.stationId,
                stationName: item.stationName,
                district: item.district,
                area: item.area,
                photoUrl: item.photoUrl,
                photoPerspectiveUrls: item.photoPerspectiveUrls,
                rubbishRating: item.rubbishRating,
               // uploadDate: new Date(item?.uploadDate).toLocaleString('en-US'), //Show  Date and Time
                uploadDate: new Date(item?.uploadDate).toLocaleDateString('en-US'), //Only Show Date
                thumbnailUrl: item.thumbnailUrl,
                //time: new Date(item.uploadDate).toLocaleTimeString('en-US'),
            }))
        }

        if (data.status === 'rejected') {
            alert(t('An error occurred. Please login again.'));
            dispatch(logOut());
            navigate('/');
        }

        // return [];
    };

    const handleClosePhoto = () => {
        setIsImageOpen(false);
        setSelectedImage(null);
    };

    const handleClosePerspectivePhoto = () => {
        setIsPerspectiveImageOpen(false);
        setSelectedPerspectiveImage(null);
    };

    const handlePhotoClick = (rowData: any) => {
        // console.log("Button clicked for row:", rowData);
        // Add your custom logic here
        setSelectedStation(rowData.row.stationName);
        setSelectedImage(rowData.row.photoUrl);
        setIsImageOpen(true);
    };

    const handlePerspectivePhotoClick = (imageUrl: string[]) => {
        //console.log("handlePerspectivePhotoClick:", imageUrl);
        // Add your custom logic here
        setSelectedPerspectiveImage(imageUrl);
        setIsPerspectiveImageOpen(true);
    };

    const handleRowClick = () => {
        // console.log('row click');
    }

    const handleSearchClick = async () => {
        try {
            setLoading(true);
            getLatestPhotoList({
                sortBy: 'uploadDate',
                sortDirection: 'asc'
            }).then(
                (res) => {
                    if (res.status === 'fulfilled') {
                        setLoading(false);
                        const tableRows = res?.data.records.map((item: any) => ({
                            id: item?.id,
                            stationId: item.stationId,
                            stationName: item.stationName,
                            district: item.district,
                            area: item.area,
                            photoUrl: item.photoUrl,
                            photoPerspectiveUrls: item.photoPerspectiveUrls,
                            rubbishRating: item.rubbishRating,
                            //uploadDate: new Date(item?.uploadDate).toLocaleString('en-US'),
                            uploadDate: new Date(item?.uploadDate).toLocaleDateString('en-US'), //Only Show Date
                            thumbnailUrl: item.thumbnailUrl,
                        }))
                        setTableRows(tableRows)
                        setData(res?.data)
                    }

                    if (res.status === 'rejected') {
                        setLoading(false);
                        alert(t('An error occurred. Please login again.'));
                        dispatch(logOut());
                        navigate('/');
                    }
                }
            )
        } catch (error) {

        }
    }
    useEffect(() => {
        // console.log("data", data)
    }, [data])

    useEffect(() => {
        handleSearchClick();
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <MainContent type={latestPhotoPageName}>
            <Box sx={{ bgcolor: '#456296' }}>
                <HeadingTitle>{t("Latest Photo Record")}</HeadingTitle>
            </Box>
            <BackgroundStyle sx={{ zIndex: 0 }}>
                {/* 360 Photo Popup */}
                <Dialog
                    open={isImageOpen}
                    onClose={handleClosePhoto}
                    maxWidth="lg"
                    fullWidth
                    PaperProps={{ sx: { borderRadius: 3 } }}
                >
                    <DialogContent sx={{ padding: 2 }}>
                        <Box sx={{ position: 'relative' }}>
                            <IconButton
                                onClick={handleClosePhoto}
                                sx={{
                                    position: 'absolute',
                                    right: 8,
                                    top: 8,
                                    color: 'white',
                                    bgcolor: 'rgba(0,0,0,0.5)',
                                    '&:hover': { bgcolor: 'rgba(0,0,0,0.7)' }
                                }}
                            >
                            </IconButton>
                            {selectedImage  && <PhotoSphereViewerComponent stationName={selectedStation} image={selectedImage} title='360 Viewer' />}
                        </Box>
                    </DialogContent>
                </Dialog>

                {/* Perspective Photo Popup */}
                <Dialog
                    open={isPerspectiveImageOpen}
                    onClose={handleClosePerspectivePhoto}
                    maxWidth="lg"
                    fullWidth
                    PaperProps={{ sx: { borderRadius: 3 } }}
                >
                    <DialogContent sx={{ padding: 2 }}>
                        <Box sx={{ position: 'relative' }}>
                            <IconButton
                                onClick={handleClosePerspectivePhoto}
                                sx={{
                                    position: 'absolute',
                                    right: 8,
                                    top: 8,
                                    color: 'white',
                                    bgcolor: 'rgba(0,0,0,0.5)',
                                    '&:hover': { bgcolor: 'rgba(0,0,0,0.7)' }
                                }}
                            >
                            </IconButton>
                            <Grid container spacing={0}>
                                {selectedPerspectiveImage && selectedPerspectiveImage.map((img,index) => (
                                    <Grid key={index} item xs={6}>
                                        <img
                                            src={`${img}?token=${localStorage.getItem('accessToken')}` || ''}
                                            alt="Full preview"
                                            style={{
                                                width: '100%',
                                                height: 'auto',
                                                maxHeight: '80vh',
                                                display: 'block', // Remove inline gaps
                                                verticalAlign: 'top', // Fix baseline spacing
                                            }}
                                        />
                                    </Grid>
                                ))
                                }
                            </Grid>
                        </Box>
                    </DialogContent>
                </Dialog>
                {isLoading && <Box sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight: 300
                }}>
                    <CircularProgress size={60} />
                </Box>}
                {!isLoading && <RecordTableV2
                    columns={getColumns()}
                    rows={tableRows}
                    checkbox={false}
                    pages={data?.totalPages}
                    totalCount={data?.totalCount}
                    onClick={handleRowClick}
                    updateTableRows={setTableRows}
                    fetchDataForPage={fetchDataForPage}
                ></RecordTableV2>
                }
            </BackgroundStyle>
        </MainContent >
    );
};
export default LatestPhotoRecord;